<div class="">

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">إدارة  الحافلات</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="input-group mb-3">
          <div class="input-icons">
            <i class="fa fa-search icon">
            </i>
            <input type="text" #search (keyup)="($event)" class="form-control transparent" placeholder="بحث في الباصات" aria-label="Recipient's username" aria-describedby="basic-addon2">

            <i class="fa fa-times-circle pointer left" *ngIf="search.value.length>0" (click)="removeSearch()"></i>

          </div>
        </div>
      </div>
      <div class="col-md-3 ml-auto">
        <button type="button" class="btn btn-outline-secondary  dashed-button" (click)="changeEditMode()" data-toggle="modal" data-target="#myModal"  > + إضافة حافلة</button>
      </div>
    </div>
  </div>
  <div class="row" >
    <div class="col-md-12">
      <div class="row" *ngIf="loader">
        <div class="col-md-12">
          <div class="text-center">
            <div class="loader"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table no-border">

            <tbody>
            <tr *ngFor="let row of buses|search: 'name' : search.value| paginate: { itemsPerPage: 10, currentPage: p }" >
              <th scope="row"  class="no-border" width="75%">
                <div class="media align-items-center">
                  <a href="javascript:void(0)" class="avatar rounded-circle mr-3 mb-4">
                    <img src="../../assets/images/icons/busFront.svg" width="35" height="45" id="" class="mt-2 mb-2" /><br/>

                  </a>
                  <div class="d-flex flex-column  ">
                    <div class="text-left">
<!--                      <small class="center m-2"> {{row.drivers?row.drivers.length>0?'تم تعيين':'لم يتم تعيين سائق':'لم يتم تعيين سائق'}}</small>-->
                        <div class="ml-2">
                      <span class="badge" style="font-size: 20px;width:100px; background: white;border:1px solid #000">{{row.bus_identity}}</span>
                      </div>


                      <div class="row mt-1">
                          <div *ngFor="let driver of row.drivers" class=" ml-2" role="alert">
                            <div class="row  m-0">
                              <div class="col-md-12 assign-driver">

                                <span class="badge   p-2" style="min-width: 200px;text-align: right;background-color: #5a616b;color:#fff"><span class="font-12 bold"><img src="../../assets/images/icons/userIconWhitee.svg" class="mr-2"/>{{driver.name}}</span></span>
                                <button type="button" class="close remove-driver" >
                                  <span aria-hidden="true"  data-toggle="modal" data-target="#unAssignModal" (click)="selectedDriverRow(row,driver)"><i class="fa fa-times pointer" style="top:0;height: unset;color:red" ></i></span>
                                </button>
                              </div>

                            </div>

<!--                          <span>{{driver.name}}</span>-->
<!--                          <button type="button" class="close" >-->
<!--                            <span aria-hidden="true"  data-toggle="modal" data-target="#unAssignModal" (click)="selectedDriverRow(row,driver)"><i class="fa fa-times-circle " style="top:0;height: unset;color:white" ></i></span>-->
<!--                          </button>-->
                        </div>
                      </div>

<!--                      <ul class="text-left p-0">-->
<!--                        style="-->
<!--                        top: 4px;-->
<!--                        border: 1px solid #0b2ef5 !important;-->
<!--                        margin-right: 5px;-->
<!--                        color: #3475d9 !important;-->
<!--                        padding: 6px;-->
<!--                        "-->
<!--                        <i *ngFor="let driver of row.drivers" class="circle"  >-->
<!--                          <div class="d-flex flex-row badge badge-secondary">-->
<!--                            <div class="py-2">-->
<!--                              <span  class="bold">{{driver.name}}  </span>-->
<!--                            </div>-->
<!--                            <div class="p-1">-->
<!--                              <i class="fa fa-times-circle" (click)="unAssignDriver(row._id,driver._id)"></i>-->
<!--                            </div>-->
<!--                    </div>-->
<!--                        </i>-->

<!--                      </ul>-->

                    </div>
                  </div>

                </div>
              </th>
              <td class="no-border">
                <div class="d-flex flex-row" >
                  <div class="mr-2  py-2"  >
                    <button class="btn background-blue-g radius-16 w-194" (click)="selectedRow(row)"  data-target="#assigneDriver" data-toggle="modal">تعيين سائق لهذه الحافلة</button>

                  </div>
                  <div class="mr-2"  >
                    <i data-toggle="modal" data-target="#myModal" (click)="getBus(row._id)" class="fa  border-green green pointer fa-pen circle"></i>

                  </div>
                  <div class="mr-2"  >
                    <i data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(row)"  class="fa  border-red red pointer fa-trash circle"></i>

                  </div>
                  <div class=""  >
                    <i data-toggle="modal" data-target="#busServices" (click)="getBusServices(row._id)"  class="fa  border-blue blue pointer fa-file circle"></i>

                  </div>

                </div>

              </td>

            </tr>
            </tbody>
          </table>

        </div>
      </div>


    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <pagination-controls [previousLabel]="'السابق'" [nextLabel]="'التالي'" (pageChange)="p = $event"></pagination-controls>

    </div>
  </div>
</div>
<!-- Trigger the modal with a button -->

<!-- Modal -->
<div class="modal fade" id="myModal"  tabindex='-1' role="dialog">
  <div class="modal-dialog "  >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">{{editMode?"تعديل":"إضافة"}} حافلة</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
        <p>معلومات الحافلة</p>
        <form [formGroup]="data">
<!--          <div class="row">-->
<!--            <div class="col-md-12">-->
<!--              <input type="text" formControlName="name" placeholder="اسم الحافلة" class="form-control">-->
<!--            </div>-->
<!--          </div>-->
          <div class="row">
            <div class="col-md-6">
              <label>رقم الحافلة</label>

              <input type="text" formControlName="bus_identity" [attr.disabled]="editMode?true:null" (keyup)="checkBusNumber()" placeholder="رقم الحافلة" class="form-control">
              <small class="red" >{{checkBusNumber()?'رقم الحافلة مدخل سابقا':''}}</small>
            </div>
            <div class="col-md-6">
              <label>رقم اللوحة</label>

              <input type="text" formControlName="plate"  placeholder="رقم اللوحة" class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label>نوع الحافلة</label>

              <input type="text" formControlName="type" placeholder="نوع الحافلة" class="form-control">
            </div>
            <div class="col-md-6">
              <label>السعة</label>

              <input type="number"  formControlName="capacity" placeholder="السعة " class="form-control">
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label>سعة المحرك</label>

              <input type="number" formControlName="motor" placeholder="سعة المحرك" class="form-control">
            </div>
            <div class="col-md-6">
              <label>ملاحطات</label>

              <textarea formControlName="notes" placeholder="ملاحطات" class="form-control">


              </textarea>
            </div>
          </div>




        </form>
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button" data-dismiss="modal"  style="width:280px" [disabled]="!data.valid||checkBusNumber()" class="btn radius-16  background-blue-g pr-5 pl-5" (click)="editMode?edit():add()">

             {{editMode?"تعديل":"إضافة"}}
                </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" id="assigneDriver" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">تعيين سائق للحافلة</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">
<div class="row">
  <div class="col-md-12">
    <div class="input-group mb-3">
      <div class="input-icons">
        <i class="fa fa-search icon">
        </i>
        <input type="text" #search2  (keyup)="($event)" class="form-control transparent" placeholder="بحث " aria-label="Recipient's username" aria-describedby="basic-addon2">
        <i class="fa fa-times-circle pointer left" *ngIf="search2.value.length>0" (click)="removeSearch()"></i>

      </div>
    </div>
  </div>
</div>
        <table class="table no-border">

          <tbody>

          <tr *ngFor="let row of drivers|search: 'name' : search2.value;let i=index" >

            <th scope="row"  class="no-border" width="75%">
              <div class="media align-items-center">
                <a href="javascript:void(0)" class="avatar rounded-circle mr-3">
                  <ngx-avatar name="{{row.name}}"></ngx-avatar>

                </a>
                <div class="" >
                  <span class="mb-0 text-sm">{{row.name}}</span>
                </div>
              </div>
            </th>
            <td class="no-border text-right">

              <div class="custom-radios" *ngIf="row.bus_id.length==0;else busTemplate">
                <div>
                  <input type="radio" [disabled]="row.bus_id.length>0"  (click)="assignToBus(row._id,rowSelected.drivers_id?rowSelected.drivers_id.includes(row._id):false)"  [checked]="selectedDrivers.includes(row._id)" id="color-1{{i*2}}"  class=" " name="hmead{{i}}" value="color-1">
                  <label for="color-1{{i*2}}">
      <span class="background-blue-g" [ngClass]="row.bus_id.length>0?'disabled':''">
        <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/242518/check-icn.svg" alt="Checked Icon" />
      </span>
                  </label>
                </div>
                </div>
              <ng-template #busTemplate>
                <img src="../../assets/images/icons/busIconLg.svg" style="width:37px" /><br/>
                <span>{{row.assign_bus}}</span>
              </ng-template>
            </td>

          </tr>
          </tbody>
        </table>

        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <button type="button" (click)="saveAssignBus()"   style="width:280px" class="btn radius-16  background-blue-g pr-5 pl-5" data-dismiss="modal" >حفظ الإضافات</button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="deleteModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content   radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">حذف  حافلة</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>
      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class="container text-center">
            <p class="text-black ">
              هل أنت متأكد من رغبتك في حذف الحافلة  ( {{rowSelected['bus_identity']}} ) ، سيتم حذف جميع البيانات المرتبطة بهذه الحافلة
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button" class="btn radius-16    background-red   pr-5 pl-5" data-dismiss="modal" (click)="removeBus(rowSelected['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="unAssignModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content   radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">حذف  سائق</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>
      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class="container text-center">
            <p class="text-black ">
                هل أنت متأكد من رغبتك في إلغاء تعيين السائق ( {{driverRow['name']}}  )  عن الحافلة رقم {{rowSelected['bus_identity']}}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button" class="btn radius-16    background-red   pr-5 pl-5" data-dismiss="modal" (click)="unAssignDriver(rowSelected['_id'],driverRow['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
<div class="modal  fade" id="busServices" tabindex='-1' role="dialog">
  <div class="modal-dialog modal-lg" >

    <!-- Modal content-->
    <div class="modal-content    radius-16" style="width: 600px">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">معلومات  الحافلة</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>
      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class="col-md-12">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="home-tab" data-toggle="tab" href="#petrol" role="tab" aria-controls="home" aria-selected="true">

               بيانات البنزين
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="profile-tab" data-toggle="tab" href="#oil" role="tab" aria-controls="profile" aria-selected="false">بيانات الزيت</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="tab-content  w-100" id="myTabContent">
            <div class="tab-pane fade show active" id="petrol" role="tabpanel" aria-labelledby="petrol-tab">
          <div class="container text-center">
          <div class="col-md-12">
            <table class="table table-bordered"  >
              <thead>
              <tr>
                <th class="blue">اسم السائق</th>
                <th class="blue">عدد الليترات</th>
                <th class="blue">ملاحظات</th>
                <th class="blue">القيمة</th>
                <th class="blue">التاريخ</th>
              </tr>


              </thead>
              <tbody>
              <ng-container *ngFor="let service of busServices">
                <tr *ngIf="service.type=='petrol'">
                  <td>

                    {{service.driver_name}}
                  </td>
                  <td>
                    {{service.petrol_litre}}
                  </td>
                  <td>
                    {{service.notes}}
                  </td>
                  <td>
                    {{service.amount}}
                  </td>
                  <td>
                    {{service.date}}
                  </td>
                </tr>

              </ng-container>
              <tr *ngIf="busServices.length==0"><td colspan="5">لا يوجد بيانات</td></tr>
              </tbody>

            </table>

          </div>
          </div>
            </div>
            <div class="tab-pane" id="oil" role="tabpanel" aria-labelledby="oil-tab">
              <div class="container text-center">
                <div class="col-md-12">
                  <table class="table table-bordered"  >
                    <thead>
                    <tr>
                      <th class="blue">اسم السائق</th>
                      <th class="blue">العداد الحالي</th>
                      <th class="blue">نوع الزيت</th>
                      <th class="blue">ملاحظات</th>
                      <th class="blue">القيمة</th>
                      <th class="blue">التاريخ</th>
                    </tr>


                    </thead>
                    <tbody>
                    <ng-container *ngFor="let service of oilBusServices">
                      <tr>
                        <td>

                          {{service.driver_name}}
                        </td>
                        <td>
                          {{service.current_counter}}
                        </td>
                        <td>
                          {{service.oil_type}}
                        </td>
                        <td>
                          {{service.notes}}
                        </td>
                        <td>
                          {{service.amount}}
                        </td>
                        <td>
                          {{service.date}}
                        </td>
                      </tr>

                    </ng-container>
                    <tr *ngIf="oilBusServices.length==0"><td colspan="6">لا يوجد بيانات</td></tr>
                    </tbody>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>
